import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
    getUser,
    getCurrentProfilePicture,
    getCurrentUsername,
} from '../../auth/selectors';
import Banner from '../../../common/Banner';
import DefaultPic from '../../../icons/defaultProfilePicture.png';

function GreetingBanner({ user, name, profilePicture }) {
    const { rolePermissions } = user;
    const { roleId } = rolePermissions;

    const subHeading =
        roleId >= 300
            ? "You're currently viewing your totals from all challenges world-wide."
            : 'You are currently viewing litter data that you have collected';

    return (
        <Banner heading={name} message={subHeading} image={profilePicture} />
    );
}

GreetingBanner.propTypes = {
    name: PropTypes.string,
    profilePicture: PropTypes.string,
    user: PropTypes.object,
};

GreetingBanner.defaultProps = {
    user: {
        fullName: '',
        profilePicture: DefaultPic,
    },
    name: '',
    profilePicture: DefaultPic,
};

const mapStateToProps = (state) => {
    return {
        user: getUser(state),
        name: getCurrentUsername(state),
        profilePicture: getCurrentProfilePicture(state),
    };
};

const ConnectedGreetingBanner = connect(mapStateToProps, null)(GreetingBanner);

export default ConnectedGreetingBanner;
